module.exports = __webpack_public_path__ + "img/tu6.f22ea912.png";